import React, { useState } from "react";
import "./Navbar.css";
import { NavLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';

const Navbar = () => {
  const [is_hidden_div_open, set_is_hidden_div_open] = useState(false);
  const show_hidden_div = () => {
    const hidden_div = document.getElementById("hidden_div");
    if (is_hidden_div_open === false) {
      hidden_div.style.display = "inline-block";
      set_is_hidden_div_open(true);
      setTimeout(() => {
        hidden_div.style.display = "none";
        set_is_hidden_div_open(false);
      }, 5000);
    } else {
      hidden_div.style.display = "none";
      set_is_hidden_div_open(false);
    }
  };

  return (
    <>
      <div id="navbar">
        <div id="logo">
          <img src="logo2.png" alt="" />
        </div>
        <div id="options">
          <ul id="ul">
            <li>
              <NavLink
                to="/"
                exact="true"
                style={{ textDecoration: "none", color: "white" }}
              >
                About
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Projects"
                exact="true"
                style={{ textDecoration: "none", color: "white" }}
              >
                Projects
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Skills"
                exact="true"
                style={{ textDecoration: "none", color: "white" }}
              >
                Skills
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Contact"
                exact="true"
                style={{ textDecoration: "none", color: "white" }}
              >
                Contact me
              </NavLink>
            </li>
          </ul>

          <div id="hidden_options" onClick={show_hidden_div}>
            <div style={{ color: "white",padding:"5px" }}>
             
              {is_hidden_div_open?(<div><CancelPresentationIcon/></div>):(<MenuIcon />)}
              
            </div>
          </div>
        </div>
      </div>
      <div id="hidden_div">
        <div>
          <NavLink
            to="/"
            exact="true"
            onClick={()=>set_is_hidden_div_open(false)}
            style={{ textDecoration: "none", color: "white" }}
          >
            <div style={{padding:"5px"}}>About</div>
          </NavLink>
        </div>
        <hr />
        <div>
          <NavLink
            to="/Projects"
            exact="true"
            onClick={()=>set_is_hidden_div_open(false)}
            style={{ textDecoration: "none", color: "white" }}
          >
            <div style={{padding:"5px"}}>Projects</div>
          </NavLink>
        </div>
        <hr />
        <div>
          <NavLink
            to="/Skills"
            exact="true"
            onClick={()=>set_is_hidden_div_open(false)}
            style={{ textDecoration: "none", color: "white" }}
          >
            <div style={{padding:"5px"}}>Skills</div>
          </NavLink>
        </div>
        <hr />
        <div>
          <NavLink
            to="/Contact"
            exact="true"
            onClick={()=>set_is_hidden_div_open(false)}
            style={{ textDecoration: "none", color: "white" }}
          >
            <div style={{padding:"5px"}}>Contact me</div>
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default Navbar;
